import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Make sure BASE_URL is correctly set
import { useNavigate, useParams } from 'react-router-dom';

const EditWatchman = () => {
    // State to hold form data
    const [name, setName] = useState('');
    const [contactNo, setContactNo] = useState('');
    const [purpose, setPurpose] = useState('');
    const [time, setTime] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { id } = useParams(); // Get the watchman id from the URL

    useEffect(() => {
        // Fetch the watchman details when the component mounts
        fetch(`${BASE_URL}watchman/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const watchman = data.data;
                    setName(watchman.name);
                    setContactNo(watchman.contact_no);
                    setPurpose(watchman.purpose);
                    setTime(formatTime(watchman.time)); // Format the time field correctly
                } else {
                    setError('Failed to fetch watchman details');
                }
            })
            .catch(error => {
                console.error('Error fetching watchman:', error);
                setError('There was an error fetching the watchman details');
            });
    }, [id]);

    // Function to format the time field to the correct format (YYYY-MM-DDTHH:MM)
    const formatTime = (time) => {
        if (!time) return '';
        // Remove the 'Z' and format the time to YYYY-MM-DDTHH:MM
        const formattedTime = time.split('T');
        return `${formattedTime[0]}T${formattedTime[1].slice(0, 5)}`;
    };

    // Handle form submit
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation for empty fields
        if (!name || !contactNo || !purpose || !time) {
            setError('All fields are required!');
            return;
        }

        // Prepare the updated data to send in the PUT request
        const updatedWatchman = {
            name,
            contact_no: contactNo,
            purpose,
            time,
        };

        // Make the PUT request to update the watchman
        fetch(`${BASE_URL}watchman/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedWatchman),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Watchman updated successfully');
                    navigate('/WatchmenList');  // Redirect to the list page after success
                } else {
                    setError(data.message || 'Failed to update watchman.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setError('There was an error updating the watchman.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Watchman</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Watchman Details</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="contactNo" className="form-label">Contact Number</label>
                                        <input
                                            type="text"
                                            id="contactNo"
                                            className="form-control"
                                            value={contactNo}
                                            onChange={(e) => setContactNo(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="purpose" className="form-label">Purpose</label>
                                        <input
                                            type="text"
                                            id="purpose"
                                            className="form-control"
                                            value={purpose}
                                            onChange={(e) => setPurpose(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="time" className="form-label">Time</label>
                                        <input
                                            type="datetime-local"
                                            id="time"
                                            className="form-control"
                                            value={time}
                                            onChange={(e) => setTime(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Watchman</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditWatchman;
